import { companyBasicValidation } from "./validationSchema";

export let podjetjeValidation = {
  ...companyBasicValidation,
};
